import store from './store/store';

// ENV Mapping
export const publicBackend = process.env.VUE_APP_BACKEND_URL;
export const apiDomain = process.env.VUE_APP_BACKEND_API;
export const algoliaAppId = process.env.VUE_APP_ALGOLIA_APPID;
export const algoliaApiKey = process.env.VUE_APP_ALGOLIA_APIKEY;
export const stripePublishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
export const googleApiKey = process.env.VUE_APP_GOOGLE_API_KEY;

// File Storage
export const fileHost = `${process.env.VUE_APP_BACKEND_URL}/storage/`;

export const userRegistrationUrl = `${apiDomain}auth/user/register`;
export const employeeResumeDocumentUrl = `${apiDomain}employee/resume/documents`;
export const getHeader = () => {
  const tokenData = store.state.user.authUser.token;
  const headers = {
    Accept: 'application/json',
    Authorization: `Bearer ${tokenData}`,
  };
  return headers;
};

/* External API-Endpoints */
export const googleGeocodeUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=';
